import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
// import { environment } from 'src/environments/environment';
// import * as build from '../../src/build-version.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private config: PrimeNGConfig) { }

  ngOnInit() {
    this.config.setTranslation({
      accept: 'Accept',
      reject: 'Cancel',
      //translations
      firstDayOfWeek: 0,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      // dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
        'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    });
  }

  // **
  //  * To display the current build version on the console
  // * /
  // displayBuildVersion(): void {
  //   console.log(
  //     `%cCurrent version: ${environment.appVersion}`,
  //     `background: #0082af; padding: 8px 12px; border-radius: 4px; color: #fafafa; font-size: x-large`
  //   );

  //   try {
  //     console.log(
  //       `%cCurrent build number: ${build?.buildVersion}`,
  //       `background: #0082af; padding: 8px 12px; border-radius: 4px; color: #fafafa; font-size: large`
  //     );
  //   } catch (e) {
  //     console.warn(e);
  //   }
  // }
}
